export default __webpack_public_path__ + "static/media/noexpl_015_DE.966902a1.png";